import { parseDecimalAmount } from '../as400CellRuleKinds';

const FACTOR_ONE = [
  'AT',
  'BG',
  'BR',
  'BU',
  'BX',
  'CD',
  'CO',
  'CS',
  'CT',
  'DZ',
  'EA',
  'FT',
  'GL',
  'GM',
  'GR',
  'H',
  'HR',
  'IN',
  'JG',
  'JR',
  'KE',
  'KT',
  'L',
  'LB',
  'LF',
  'LG',
  'LN',
  'M',
  'ML',
  'MM',
  'OZ',
  'PC',
  'PG',
  'PK',
  'PR',
  'PT',
  'QH',
  'QT',
  'RE',
  'RL',
  'SF',
  'SH',
  'SP',
  'ST',
  'T',
  'TB',
  'TG',
  'TN',
  'WT',
  'YD',
] as const;

const FACTOR_HUNDREDTH = ['C', 'CF', 'CL', 'CM', 'HM'] as const;
const FACTOR_THOUSANDTH = ['K', 'KF', 'KG', 'KM'] as const;

function entriesFor(
  codes: readonly string[],
  factor: number,
): ReadonlyArray<readonly [string, number]> {
  return codes.map((code) => [code, factor] as const);
}

export const SELL_UOM_PRICING_FACTORS: Readonly<Record<string, number>> =
  Object.fromEntries([
    ...entriesFor(FACTOR_ONE, 1),
    ...entriesFor(FACTOR_HUNDREDTH, 0.01),
    ...entriesFor(FACTOR_THOUSANDTH, 0.001),
  ]);

export function expectedPricingFactor(sellUom: string | null): number | null {
  if (sellUom === null) return null;
  const mapped = SELL_UOM_PRICING_FACTORS[sellUom.trim().toUpperCase()];
  return mapped === undefined ? null : mapped;
}

export function pricingFactorMatches(
  value: string | null,
  expected: number,
): boolean {
  return parseDecimalAmount(value) === expected;
}

export function formatPricingFactor(factor: number): string {
  return String(factor).replace(/^0\./, '.');
}
